import { Grid2 } from "@mui/material";
import React from "react";
import useViewOnOpen from "../../Hooks/useViewOnOpen";
import { GridContainerLayoutModel } from "../../Models/GridContainerLayoutModel";
import { GridContainerModel } from "../../Models/GridContainerModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";

const GridContainerComponent: React.FC<IComponentProps<GridContainerModel>> = ({ component, context }) => {
  const spacing = component.Spacing ?? 2;

  useViewOnOpen(component, context, "GridContainerComponent");

  return (
    <Grid2 container spacing={spacing} sx={{ overflow: "auto" }}>
      {component.Children.map((child) => {
        const layout = child.Layout as GridContainerLayoutModel;
        const size = layout?.Size ?? 12;

        return (
          <Grid2 key={child.Id} size={size} sx={{ minWidth: 0, overflow: "hidden" }}>
            <ComponentFactory parent={component} component={child} context={context} />
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default GridContainerComponent;
